<template>
  <div class="row help-wrapper">
    <div v-if="loading === false" id="corpo" class="col s12 m8 offset-m2 border-color-pri scale-transition z-depth-1">
      <h5>Atenção</h5>
      <p>O seu cadastro foi analisado por um técnico e as seguintes inconsistências foram encontradas: </p>
      <p v-html="review_info['message']"></p>
      <p>
        <span>{{ higinizador.data_hora }}</span>
        <br />
        Data/Hora
      </p>
      <p>
        <span>{{ higinizador.nome }}</span>
        <br />
        Responsável técnico
      </p>
      <a @click="goHome" class="waves-effect waves-light btn">Corrigir inconsistências</a>
    </div>
    <div v-else class="loading-wrapper">
      <loading />
    </div>
  </div>
</template>
<script>
import axios from 'axios' //5350746737874881475

import Loading from '@/components/Loading.vue'
import {formataData, converteTimestamp, converteData, converteDataHora} from '@/assets/js/form-utils.js'
import SocialService from '@/services/social-service.js'

import {CONFIG} from '@/config/config.js'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

export default {
  name: 'Review',
  components: {
    loading: Loading
  },
  data (){
    return {
      loading: true,
      review_info: {},
      pf_id: this.$store.state.user.pfId,
      higinizador: {
        nome: 'Carregando...',
        data_hora: 'Carregando...'
      }
    }
  },
  methods: {
    getReviewInfo(){
      axios.get(`${CONFIG.URL_RECAD_API_V2}/v1/higienize-segurado/${this.pf_id}/`)
      .then((response) => {

        if(response.data.data.RecadAPI.status === 'released'){
          this.review_info = response.data.data.RecadAPI
        } else {//Cadastro não está em review
          this.$router.push('/Censo/')
        }

          socialService.exchange([this.review_info.uupfid], ['nome', 'cpf',], true)
          .then((social_data) => {
            this.higinizador.nome = social_data[this.review_info.uupfid]['nome']
          })
          .catch ((error) => {
            this.higinizador.nome = "N/D"
          })
          .finally(() => {
            this.higinizador.data_hora = converteDataHora(response.data.data.RecadAPI.data_hora)
          })

        this.loading = false
      })
      .catch((error) => {
        //Cadastro aberto
      })
    },
    goHome() {
      this.$router.push('/Censo/')
    }
  },
  mounted(){
    localStorage.setItem('reviewd', true)
    this.$root.$emit('stopLoadingHeader')
    this.getReviewInfo()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Review.vue